import ApplicationAdapter from 'lumen/adapters/application';

export default class DestinationSubscriptionAdapter extends ApplicationAdapter {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  urlForFindRecord(id: string) {
    return `/destinationsubscriptions/${id}/`;
  }
}
